import { css } from '@linaria/core';
export const Icon = {
    base: css `
		position: absolute;
		z-index: 2;
		right: 0;
		bottom: 0;

		svg {
			path {
				fill: rgb(var(--text-color-body-01));
			}
		}
	`,
    isInWatchlist: css `
		svg {
			path {
				/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
				fill: #000;
			}
		}
	`,
};
